<ng-template #zoomMeetingTemplate let-model="item">
	<span>{{ model | zoomMeetingFormat }}</span>
</ng-template>

<section ngForm="zoomInputForm">
	<vb-ui-horizontal-form-group>
		<label #uiLabel></label>

		<div uiControl>

			<input type="text" class="form-control" name="zoomMeetingId" [attr.aria-label]="'Zoom_MeetingId' | translate" autocomplete="off" [placeholder]="'Zoom_MeetingId' | translate" required vbZoomMeetingId #zoomMeetingId="ngModel" [(ngModel)]="webcast.zoom.meetingId" (typeaheadLoading)="ZoomService.loading" typeaheadOptionField="id" role="combobox" [typeahead]="ZoomService.meetings" [typeaheadItemTemplate]="zoomMeetingTemplate" [typeaheadMinLength]="0"/>

			<div [ngClass]="styles.helpBlock">{{ 'Event_Edit_ZoomMeetingIdHelpText' | translate }}</div>
		</div>
		<div *ngIf="zoomMeetingId.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (zoomMeetingId.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (zoomMeetingId.errors.zoomMeetingId) {
				{{ 'Event_Edit_InvalidZoomMeetingId' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label #uiLabel></label>

		<div uiControl>

			<input type="text" class="form-control" name="zoomMeetingPassword" [attr.aria-label]="'Zoom_MeetingPassword' | translate" autocomplete="off" [placeholder]="'Zoom_MeetingPassword' | translate" [(ngModel)]="webcast.zoom.meetingPassword" #zoomMeetingPassword="ngModel" pattern="^\d{1,10}$"/>

			<div [ngClass]="styles.helpBlock">{{ 'Event_Edit_ZoomMeetingPasswordHelpText' | translate }}</div>
		</div>

		<div *ngIf="zoomMeetingPassword.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (zoomMeetingPassword.errors.pattern) {
				{{ 'Event_Edit_InvalidZoomMeetingPassword' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>
</section>
